export default "__VITE_ASSET__670fc60f__"